<template>
    <div>
        <p class="text-sm font-medium text-slate-700">{{ label }}</p>
        <div v-if="selected.length" class="mt-2 flex flex-wrap gap-1.5">
            <button
                v-for="option in selected"
                :key="option.value"
                type="button"
                class="inline-flex items-center gap-1 rounded-md bg-slate-900 px-2 py-1 text-xs font-medium text-white"
                :aria-label="`Remove ${option.label}`"
                @click="toggle(option.value)"
            >
                {{ option.label }} <span aria-hidden="true" class="text-white/70">&times;</span>
            </button>
        </div>
        <div class="mt-2 overflow-hidden rounded-lg border border-slate-300 bg-white">
            <input
                v-model="search"
                type="search"
                :placeholder="placeholder"
                :aria-label="placeholder"
                class="w-full border-0 border-b border-slate-200 px-3 py-2 text-sm text-slate-900 placeholder-slate-400 focus:border-slate-200 focus:ring-0"
            />
            <div class="max-h-44 overflow-y-auto py-1">
                <label
                    v-for="option in visible"
                    :key="option.value"
                    class="flex cursor-pointer items-center gap-2.5 px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-50"
                >
                    <input
                        type="checkbox"
                        class="h-4 w-4 rounded border-slate-300 text-slate-900 focus:ring-slate-400"
                        :checked="modelValue.includes(option.value)"
                        @change="toggle(option.value)"
                    />
                    {{ option.label }}
                </label>
                <p v-if="!visible.length" class="px-3 py-2 text-sm text-slate-400">Nothing found</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: { type: String, required: true },
        placeholder: { type: String, default: "Search" },
        options: { type: Array, default: () => [] },
        modelValue: { type: Array, default: () => [] },
    },
    emits: ["update:modelValue"],
    data() {
        return { search: "" };
    },
    computed: {
        selected() {
            return this.options.filter((option) => this.modelValue.includes(option.value));
        },
        visible() {
            const search = this.search.trim().toLowerCase();
            return search ? this.options.filter((option) => option.label.toLowerCase().includes(search)) : this.options;
        },
    },
    methods: {
        toggle(value) {
            this.$emit(
                "update:modelValue",
                this.modelValue.includes(value) ? this.modelValue.filter((item) => item !== value) : [...this.modelValue, value]
            );
        },
    },
};
</script>
